<script lang="ts">
  import { t } from '$lib/i18n';
  import { createQueries } from '@tanstack/svelte-query';
  import ProductGrid from '../product-grid.svelte';
  import { recentlyViewed } from '$lib/recently-viewed';
  import { shopify } from '$lib/shopify';
  import { getPDPProductContext } from '$lib/contexts/pdp-product';
  import type { RecentlyViewedStoryblok } from '$types/bloks';
  import { lang } from '$lib/lang';
  import type { LanguageCode } from '$gql/storefront/schemas';
  import { optimalUSCountry, parseCountryAsCode } from '$lib/country';

  export let block: RecentlyViewedStoryblok;

  $: pdpContext = getPDPProductContext();
  $: handlesFromStorage = pdpContext
    ? $recentlyViewed.filter((h) => h !== pdpContext?.handle)
    : $recentlyViewed;

  $: handles = block.amount
    ? handlesFromStorage.slice(0, Number(block.amount))
    : handlesFromStorage;

  $: queries = createQueries(
    handles.map((handle) => ({
      staleTime: 5 * 60 * 1000,
      queryKey: ['productCard', handle, $lang],
      queryFn: async () => {
        return await $shopify.getProductCard({
          handle,
          lang: $lang.toUpperCase() as LanguageCode,
          country: parseCountryAsCode($optimalUSCountry)
        });
      }
    }))
  );

  $: arr = $queries.map((q) => q.data?.product);
  $: products = arr.filter(Boolean) as NonNullable<(typeof arr)[number]>[];

  let containerWidth = 0;
  let screenSize = 0;
</script>

<svelte:window bind:innerWidth={screenSize} />

{#if products.length >= 3}
  <section class="px-2 lg:px-8 !py-0">
    <div
      class="container mx-auto lg:pt-0 pt-[88px] mb-2 lg:mb-0 relative"
      bind:clientWidth={containerWidth}
    >
      <h2 class="px-2 lg:px-0 text-4xl font-semibold top-[88px] lg:absolute left-0 right-0">
        {block.title || $t('pdp.recently-viewed')}
      </h2>
    </div>

    <div class="lg:pt-[88px]">
      <div
        style:--x-margin={`${(screenSize - containerWidth) / 2 || 16}px`}
        class="py-2 lg:py-8 lg:pt-0"
      >
        <ProductGrid {products} loading={$queries.some((q) => q.isLoading)} />
      </div>
    </div>
  </section>{/if}
